import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../src/Box.docs.json';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentProps = makeShortcode("ComponentProps");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {Box} from '@primer/react'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <h3>{`Border on all sides`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Box borderColor="border.default" borderWidth={1} borderStyle="solid" p={3}>
  Hello
</Box>
`}</code></pre>
    <h3>{`Border on one side`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Box borderColor="border.default" borderBottomWidth={1} borderBottomStyle="solid" pb={3}>
  Hello
</Box>
`}</code></pre>
    <h3>{`Flexbox`}</h3>
    <p>{`Use Box to create `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Flexbox"
      }}>{`flexbox`}</a>{` layouts.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Box display="flex">
  <Box p={3} borderColor="border.default" borderWidth={1} borderStyle="solid">
    1
  </Box>
  <Box flexGrow={1} p={3} borderColor="border.default" borderWidth={1} borderStyle="solid">
    2
  </Box>
  <Box p={3} borderColor="border.default" borderWidth={1} borderStyle="solid">
    3
  </Box>
</Box>
`}</code></pre>
    <h3>{`Grid`}</h3>
    <p>{`Use Box to create `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Grids"
      }}>{`grid`}</a>{` layouts.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Box display="grid" gridTemplateColumns="1fr 1fr" gridGap={3}>
  <Box p={3} borderColor="border.default" borderWidth={1} borderStyle="solid">
    1
  </Box>
  <Box p={3} borderColor="border.default" borderWidth={1} borderStyle="solid">
    2
  </Box>
  <Box p={3} borderColor="border.default" borderWidth={1} borderStyle="solid">
    3
  </Box>
</Box>
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: true,
      usedInProduction: true,
      usageExamplesDocumented: true,
      designReviewed: null,
      a11yReviewed: null,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: null,
      hasFigmaComponent: null
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      